export const durations = [
    {
        "id": 1,
        "name": "7 jours",
        "percentage": 15,
        "slug": "7 day"
    },
    {
        "id": 2,
        "name": "15 jours",
        "percentage": 20,
        "slug": "15 day"
    },
    {
        "id": 3,
        "name": "1 mois",
        "percentage": 25,
        "slug": "1 month"
    },
    {
        "id": 4,
        "name": "2 mois",
        "percentage": 35,
        "slug": "2 month"
    },
    {
        "id": 5,
        "name": "3 mois",
        "percentage": 40,
        "slug": "3 month"
    },
    {
        "id": 6,
        "name": "4 mois",
        "percentage": 50,
        "slug": "4 month"
    },
    {
        "id": 7,
        "name": "5 mois",
        "percentage": 55,
        "slug": "5 month"
    },
    {
        "id": 8,
        "name": "6 mois",
        "percentage": 70,
        "slug": "6 month"
    },
    {
        "id": 9,
        "name": "7 mois",
        "percentage": 75,
        "slug": "7 month"
    },
    {
        "id": 10,
        "name": "8 mois",
        "percentage": 90,
        "slug": "8 month"
    },
    {
        "id": 11,
        "name": "9 mois",
        "percentage": 100,
        "slug": "9 month"
    },
    {
        "id": 12,
        "name": "1 an",
        "percentage": 100,
        "slug": "1 year"
    }
]